import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["amount", "total", "available"]
  static values = { maxAmount: Number }

  connect() {
    this.amountChanged()
  }

  amountChanged() {
    let amount = parseFloat(this.amountTarget.value) || 0

    if (amount > this.maxAmountValue) {
      amount = this.maxAmountValue
      this.amountTarget.value = amount.toFixed(2)
    }

    if (amount < 0) {
      amount = 0
      this.amountTarget.value = "0.00"
    }

    const remaining = Math.max(this.maxAmountValue - amount, 0)

    this.totalTarget.textContent = this.currency(amount)

    if (this.hasAvailableTarget) {
      this.availableTarget.textContent = this.currency(remaining)
    }
  }

  currency(value) {
    return value.toLocaleString("de-DE", {
      style: "currency",
      currency: "EUR"
    })
  }
}